'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var analytics = require('analytics');

var _excluded = ["initialize", "loaded"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];

/**
 * Check if pixel script has loaded in DOM
 *
 * @param {string} scriptSrc - the src of the pixel script to check for
 * @returns {boolean}
 */
var scriptLoaded = function scriptLoaded(scriptSrc) {
  var _document;
  var scripts = Object.values(((_document = document) === null || _document === void 0 ? void 0 : _document.scripts) || {});
  var srcRegex = new RegExp("^" + scriptSrc);
  return !!scripts.find(function (script) {
    return srcRegex.test(script.src);
  });
};

/**
 * Load pixel script on initialize into DOM
 *
 * @param {string} scriptSrc - the src of the pixel script to load
 * @returns {boolean}
 */
var loadScript = function loadScript(scriptSrc) {
  var pixelScript = document.createElement('script');
  pixelScript.async = true;
  pixelScript.src = scriptSrc;
  pixelScript.type = 'text/javascript';

  // Fast way to insert assuming at least one other exists (instead of head)
  var script = document.getElementsByTagName('script')[0];
  script.parentNode.insertBefore(pixelScript, script);
};

/**
 *
 * @param {object} pluginConfig - Configuration object with information specific to the pixel being created
 * @param {string|null} [pluginConfig.publisherId] - id of publisher for user being tracked
 * @param {string} [pluginConfig.context] - The app which is instantiating the particular plugin
 * @param {string} pluginConfig.provider - Name of the pixel provider i.e. Twitter, TikTok, Facebook, etc.
 * @param {object} [pluginConfig.pixelConfig] - Custom Pixel config specific to the third-party being used
 * @param {string} pluginConfig.pixelConfig.scriptSrc - Pixel Script to load pixel, provided by the app being integrated
 * @param {object} [pluginConfig.customMethods] - Any custom methods needed within the Pixel Plugin, possibly for accessing/setting data in storage
 * @param {object} [pluginConfig.coreEvents] - @see https://github.com/DavidWells/analytics/blob/master/packages/analytics-core/src/events.js for a reference of all events
 * @returns {object}
 */

var createPixelPlugin = function createPixelPlugin(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$provider = _ref.provider,
    provider = _ref$provider === void 0 ? 'pico' : _ref$provider,
    _ref$publisherId = _ref.publisherId,
    publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? 'gadget' : _ref$context,
    _ref$pixelConfig = _ref.pixelConfig,
    pixelConfig = _ref$pixelConfig === void 0 ? {} : _ref$pixelConfig,
    _ref$customMethods = _ref.customMethods,
    customMethods = _ref$customMethods === void 0 ? {} : _ref$customMethods,
    _ref$coreEvents = _ref.coreEvents,
    coreEvents = _ref$coreEvents === void 0 ? {} : _ref$coreEvents,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var pixelPluginConfig = Object.assign({
    context: context,
    publisherId: publisherId
  }, pixelConfig, {
    scriptLoaded: scriptLoaded
  });
  var _coreEvents$initializ = coreEvents.initialize,
    customInitialize = _coreEvents$initializ === void 0 ? function () {} : _coreEvents$initializ,
    _coreEvents$loaded = coreEvents.loaded,
    customLoaded = _coreEvents$loaded === void 0 ? function () {
      return true;
    } : _coreEvents$loaded,
    customCoreEvents = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(coreEvents, _excluded);
  var name = "analytics-plugin-" + provider + "-pixel";
  return Object.assign({
    name: name,
    enabled: enabled,
    config: pixelPluginConfig,
    /**
     * Core Events
     * @see https://github.com/DavidWells/analytics/blob/master/packages/analytics-core/src/events.js for a list of core events
     * The Pixel Factory comes with load script run at initialization
     *
     * Args supplied to events: [config, instance, abort, payload, plugins]
     */
    initialize: function initialize(_ref2) {
      var config = _ref2.config;
      var scriptSrc = config.scriptSrc;

      /**
       * Load the pixel if not loaded already by injecting script into document
       */
      if (!scriptLoaded(scriptSrc)) {
        loadScript(scriptSrc);
        customInitialize();
        console.log(name + " has loaded!");
      }
    },
    //
    loaded: function loaded() {
      var scriptSrc = pixelPluginConfig.scriptSrc;
      return pixelPluginConfig.scriptLoaded(scriptSrc) && customLoaded(pixelPluginConfig);
    }
  }, customCoreEvents, {
    /**
     * Custom Methods
     */
    methods: Object.assign({
      guest: function guest(_ref3) {
        if (_ref3 === void 0) {
          _ref3 = {};
        }
        var _ref4 = _ref3,
          id = _ref4.id,
          traits = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref4, _excluded2);
        this.instance.storage.setItem(analytics.CONSTANTS.ANON_ID, id);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_TRAITS, traits);
      },
      user: function user(_ref5) {
        if (_ref5 === void 0) {
          _ref5 = {};
        }
        var _ref6 = _ref5,
          id = _ref6.id,
          traits = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref6, _excluded3);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_ID, id);
        this.instance.storage.setItem(analytics.CONSTANTS.USER_TRAITS, traits);
      }
    }, customMethods)
  });
};
var createPixelPlugin$1 = createPixelPlugin;

module.exports = createPixelPlugin$1;
//# sourceMappingURL=createPixelPlugin.js.map
